// extracted by mini-css-extract-plugin
export default {"header":"PrimaryHeading_header__0iKDK"};